import View from '../../../View'
import {connect} from '../../../redux/utils'
import {getCollapsedProjects} from '../selectors'
import {storeCollapsedProjectsState} from '../utils'

export class LocalSettingsUpdater extends View {
    constructor() {
        super()

        this.state = {
            collapsedProjects: {}
        }

        this.onStatePropertyDeeplyChanged('collapsedProjects', (collapsedProjects) => {
            if (collapsedProjects) storeCollapsedProjectsState(collapsedProjects)
        })
    }
}

export default connect((state) => ({
    collapsedProjects: getCollapsedProjects(state)
}))(LocalSettingsUpdater)



// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/LocalSettingsUpdater.js